import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ConfigConstants, ConfirmationSourceReplacementsModel, SourceReplacementModel } from '@evorait/pace-core';
import { faTrash, faTrashRestore } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-confirmation-source-replacements',
    templateUrl: './confirmation-source-replacements.component.html',
    styleUrls: ['./confirmation-source-replacements.component.scss'],
})
export class ConfirmationSourceReplacementsComponent implements OnInit {
    @Input()
    public model: ConfirmationSourceReplacementsModel;

    @Input()
    public parentForm: FormArray;

    public sourceReplacementsForm: FormGroup;
    public sourceReplacementsFormChildren: FormArray;
    public readonly faTrash = faTrash;
    public readonly faTrashRestore = faTrashRestore;
    public readonly deleteCode = ConfigConstants.SOURCE_REPLACEMENT_INDICATOR.DELETED;
    public readonly maxSourceReplacements = ConfigConstants.SOURCE_REPLACEMENT_MAX_ENTRIES;

    public constructor(
        private readonly formBuilder: FormBuilder,
        private readonly changeDetector: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        this.sourceReplacementsFormChildren = this.formBuilder.array([]);
        this.sourceReplacementsForm = this.formBuilder.group({
            children: this.sourceReplacementsFormChildren,
        });
        this.parentForm.push(this.sourceReplacementsForm);
    }

    public addSourceReplacement(): void {
        const sourceReplacement = new SourceReplacementModel();
        this.model.sourceReplacements.addModel(sourceReplacement);
        this.changeDetector.detectChanges();
    }

    public deleteSourceReplacement(sourceReplacement: SourceReplacementModel, index: number): void {
        if (sourceReplacement.changeIndicatorCode === ConfigConstants.SOURCE_REPLACEMENT_INDICATOR.ADDED) {
            this.model.sourceReplacements.removeModel(index);
        } else if (sourceReplacement.changeIndicatorCode === this.deleteCode) {
            sourceReplacement.sourceReplacementRestored();
        } else {
            sourceReplacement.sourceReplacementDeleted();
        }
        this.changeDetector.detectChanges();
    }

    public calibrationDateChanged(sourceReplacement: SourceReplacementModel): void {
        sourceReplacement.calibrationDateChanged();
        this.changeDetector.detectChanges();
    }

    public changeIndicatorChanged(sourceReplacement: SourceReplacementModel): void {
        sourceReplacement.changeIndicatorChanged();
        this.changeDetector.detectChanges();
    }

    public activeSourceReplacements(): number {
        const sourceReplacements: SourceReplacementModel[] = this.model?.sourceReplacements?.value || [];
        if (sourceReplacements.length === 0) {
            return 0;
        }
        return sourceReplacements.filter(
            (sourceReplacement) => sourceReplacement.changeIndicatorCode !== this.deleteCode,
        ).length;
    }
}
